import React, { useState } from "react";
import { Router } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import history from "./Store/history/history";
import defaultRoutes from "./Routes/Routes";
import PrivateRoute from './Routes/PrivateRoutes';
//import ToastMessage from './Components/ToastMessage';
import { setStartLoader, setStopLoader } from './Store/action/loader';
import { getTheme, setTheme } from './Store/action/theme';
import { getUser, setUser } from './Store/action/user';
import { useEffect } from "react";
import { _theme, _user, _rawFetch, _list, _spendingControl } from "./Store/action/crud";
import * as constants from './Utils/constants';
import { isLogin, setToken } from "./Utils/token";
import { getTenantName, isHomeWidget } from "./Utils";
import { BASE_URL } from "./Utils/url";
import { initDisableAutofill } from "./Utils/disableAutofill";
import pkg from '../package.json'
import { isService1Tenant } from "./Utils/ServiceProviders/lumin";
import { isBannoServiceProvider, loadBannoBridge } from "./Utils/ServiceProviders/banno";
import GoodnightProcess from "./Components/GoodnightProcess/GoodnightProcess";

let routes = defaultRoutes;
let tenantsName = constants.ENTITY_BRAND.MAZOOLA;

tenantsName = getTenantName();


function App(props) {
  const [appReady, setAppReady] = useState(false);
  const {
    toast,
  } = props
  const resolvePrivateRoutes = (routes) => {

    if (routes && Array.isArray(routes)) {
      return routes.map((route) => {

        if (route.isPrivate) {
          route.render = (props) => (
            <PrivateRoute component={route.component} {...props} />
          );
        }
        if (route.isAuth) {
          route.render = (props) => (
            <PrivateRoute component={route.component} {...props} />
          );

        }
        if (route.routes) {
          resolvePrivateRoutes(route.routes);
        }
        return route;
      });
    }
  };

  useEffect(() => {
    initDisableAutofill();
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isService1Tenant(props.tenantFullName, false)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://api.glia.com/salemove_integration.js';
      document.head.appendChild(script);
    }
  }, [props.tenantFullName]);// eslint-disable-line react-hooks/exhaustive-deps

  // #14286: the "Back to Dashboard" shell (public/banno-template.js) asks this frame to
  // call requestClose() itself, rather than calling window.Bridge.requestClose() directly
  // from the shell - see homeRedirectTenantWise (Utils/ServiceProviders/index.js) for the
  // same already-working requestClose() pattern used elsewhere from inside this app.
  useEffect(() => {
    if (!isBannoServiceProvider(props.tenantFullName, false)) {
      return;
    }

    loadBannoBridge(props.tenantFullName);

    const handleParentMessage = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }
      if (event.data?.type !== "BANNO_REQUEST_CLOSE") {
        return;
      }

      // 1. Notify shell FIRST — on Android, requestClose() destroys this JS context
      //    immediately, so the postMessage must go out before the call or it is lost.
      try {
        window.parent.postMessage({ type: "BANNO_REQUEST_CLOSE_DONE" }, window.location.origin);
      } catch (e) { /* cross-origin guard — shell handles gracefully */ }

      // 2. Then call requestClose() — plugin framework requires this from the inner frame.
      //    On Android this may immediately tear down the frame; order is intentional.
      try {
        if (window.Bridge && typeof window.Bridge.requestClose === "function") {
          window.Bridge.requestClose();
        }
      } catch (e) { /* bridge unavailable or context already being torn down */ }

    };

    window.addEventListener("message", handleParentMessage);
    return () => window.removeEventListener("message", handleParentMessage);
  }, [props.tenantFullName]);

  useEffect(() => {

    checkAppVersion();

    const tenant = localStorage.getItem("banno");
    if (tenant === "1") {
      setToken(localStorage.getItem("access_token"))
    }
    fetchTheme();
    if (isLogin()) {
      fetchUser();
    }

  }, []);// eslint-disable-line react-hooks/exhaustive-deps


  const fetchTheme = () => {

    const contrast = sessionStorage.getItem('contrast');
    if (contrast === "false") {
      sessionStorage.removeItem('contrast')
    }

    props._rawFetch(`${BASE_URL.CDN}/lists/branding.json`, null, response => {
      setTimeout(() => {
        setAppReady(true);
      }, 100);

    }, err => {
      setTimeout(() => {
        setAppReady(true);
      }, 100);
    })

    props._spendingControl(`/assets/configs/spendingcontrol.json`, null, response => {
    }, err => {
    })

  }

  const fetchUser = () => {
    if (isHomeWidget()) { return }
    props._user(constants.V6USERS, "", (res) => {

    })
  }

  const checkAppVersion = async () => {
    const CURRENT_VERSION = pkg.version; // inject during build

    async function checkVersion() {
      try {
        const res = await fetch('/version.json?t=' + new Date().getTime());
        const data = await res.json();

        if (data.version !== CURRENT_VERSION) {
          window.location.reload(true); // force refresh
        }
      } catch (err) {
        console.log("Version check failed", err);
      }
    }

    // call every 30–60 seconds
    setInterval(checkVersion, 60000);
  }

  if (!appReady) {
    return null; // or <Loader />
  }

  return (
    <>
      <GoodnightProcess />
      <Router history={history} basename={process.env.PUBLIC_URL}>
        {/* <ToastMessage toastData={toast && toast} /> */}

        {renderRoutes(resolvePrivateRoutes(routes))}

      </Router>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    toast: state.loader.toast,
    loaderStatus: state.loader.loaderStatus,
    tenantsName: tenantsName,
    tenantFullName: state.theme.values.tenantFullName
  }
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    // showToastMessage,
    // resetToastMessage,
    setStartLoader,
    setStopLoader,
    getTheme,
    setTheme,
    setUser,
    getUser,
    _theme,
    _spendingControl,
    _user,
    _rawFetch,
    _list
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
